/**
 * Splits a string into separate tokens, discards all tokens with less than two characters
 * @param str
 * @returns
 */
export function tokenize(str: string): string[] {
    return str.toLowerCase().split(/\W|_/);
    // we cannot filter for length because "z" and "r", "i","u" are important and extremely valuable names for sdss...
    // .filter(x => x.length > 1);
}

/**
 * Splits a string into separate tokens by white space
 * @param str
 * @returns
 */
export function tokenizeByWhitespace(str: string): string[] {
    return str.toLowerCase().split(/\s|_/);
}

export function substringAround(
    str: string,
    position: number,
    range: number
): string {
    const max = str.length;
    if (position - range >= max) {
        return "";
    }
    const upper = Math.min(position + range, max);
    const lower = Math.max(position - range, 0);
    return str.substring(lower, upper);
}
